app.service("LegalAgreementAPI", [
    "$http",
    "ENV",
    "Session",
    function ($http, ENV, Session) {
        const baseUri = ENV.API + "/api/legal-agreement";

        /**
         * Generates the common headers required for API authentication.
         * @returns {Object} The headers object.
         */
        const getHeaders = function () {
            return {
                Authorization: "Bearer " + Session.token,
                "X-PRACTICE-ID": Session.practice ? `${Session.practice.id}` : null,
            };
        };

        var service = {

            // =================================================================
            // Document Management (Admin/Internal)
            // =================================================================

            /**
             * Adds a new legal agreement document.
             * Maps to: POST /api/legal-agreement/document
             * * @param {Object} documentData - The document request payload.
             */
            createDocument: function (documentData) {
                return $http({
                    method: "POST",
                    url: `${baseUri}/document`,
                    data: documentData,
                    headers: getHeaders()
                });
            },

            /**
             * Updates an existing legal agreement document to a new version.
             * Maps to: PUT /api/legal-agreement/document/{documentId}/version
             * * @param {String} documentId - The UUID of the document to update.
             * @param {Object} documentData - The document request payload.
             */
            updateDocumentVersion: function (documentId, documentData) {
                return $http({
                    method: "PUT",
                    url: `${baseUri}/document/${documentId}/version`,
                    data: documentData,
                    headers: getHeaders()
                });
            },

            /**
             * Retrieves all active legal agreement documents.
             * Maps to: GET /api/legal-agreement/document
             */
            getAllActiveDocuments: function () {
                return $http({
                    method: "GET",
                    url: `${baseUri}/document`,
                    headers: getHeaders()
                });
            },

            // =================================================================
            // User Endpoints
            // =================================================================

            /**
             * Retrieves all pending legal agreement documents for the logged-in user.
             * Maps to: GET /api/legal-agreement/pending
             */
            getPendingDocuments: function () {
                return $http({
                    method: "GET",
                    url: `${baseUri}/pending`,
                    headers: getHeaders()
                });
            },

            /**
             * Records that the logged-in user has accepted a specific legal agreement document.
             * Maps to: POST /api/legal-agreement/document/{documentId}/accept
             * * @param {String} documentId - The UUID of the document being accepted.
             */
            acceptDocument: function (documentId) {
                return $http({
                    method: "POST",
                    url: `${baseUri}/document/${documentId}/accept`,
                    headers: getHeaders()
                });
            }
        };

        return service;
    },
]);